/**
 * Container do sino (C-24): injeta o hook e entrega a lista ao componente de apresentação.
 * Montado só com usuário e perfil resolvidos — o texto (leigo × técnico) e a relevância
 * dependem do perfil, e sem sessão as queries não têm o que ler.
 */
import type { NotifProfile } from '@/domain/tarp/notificacoes';
import { useNotificacoesDoSino } from '@/hooks/useNotificacoesDoSino';
import NotificationBell from './NotificationBell';

export default function SinoDeNotificacoes({ profile }: { profile: NotifProfile }) {
  const sino = useNotificacoesDoSino(profile);
  return (
    <NotificationBell
      notificacoes={sino.notificacoes}
      lidas={sino.lidas}
      isLoading={sino.isLoading}
      error={sino.error}
      agora={sino.agora}
      onAbrir={sino.abrir}
      onMarcarTodas={sino.marcarTodasLidas}
    />
  );
}
